const RECURSOS_TROCA_PLANO = [
  { codigo: "DOCUMENTOS_ATIVOS", rotulo: "Documentos ativos", campoUso: "documentosAtivos" },
  { codigo: "USUARIOS_OPERACIONAIS", rotulo: "Usuários", campoUso: "usuariosOperacionais" },
  { codigo: "FILIAIS", rotulo: "Filiais", campoUso: "filiais" },
  { codigo: "FORNECEDORES", rotulo: "Fornecedores", campoUso: "fornecedores" },
];

export function avaliarCompatibilidadePlano({ uso, limitesDestino, nomePlano }) {
  const violacoes = [];

  for (const recurso of RECURSOS_TROCA_PLANO) {
    const limite = limitesDestino?.[recurso.codigo];
    if (limite == null) continue;
    const atual = Number(uso?.[recurso.campoUso]) || 0;
    if (atual > limite) {
      violacoes.push({
        codigo: recurso.codigo,
        rotulo: recurso.rotulo,
        uso_atual: atual,
        limite_destino: limite,
      });
    }
  }

  if (!violacoes.length) {
    return { compativel: true, violacoes: [] };
  }

  const detalhes = violacoes
    .map(
      (v) =>
        `${v.rotulo}: ${v.uso_atual.toLocaleString("pt-BR")} (limite do plano ${nomePlano}: ${v.limite_destino.toLocaleString("pt-BR")})`
    )
    .join("; ");

  return {
    compativel: false,
    violacoes,
    mensagem: `Não é possível alterar para o plano ${nomePlano}. Seu uso atual excede os limites: ${detalhes}.`,
  };
}

export function podeSelecionarPlano({ plano, uso, catalogoPlanos, toast }) {
  if (!plano?.codigo || !uso) return true;

  const planoCatalogo = catalogoPlanos?.find(
    (item) => String(item.id || item.codigo).toLowerCase() === String(plano.codigo).toLowerCase()
  );
  const limitesDestino = planoCatalogo?.limites;
  const nomePlano = plano.nome || planoCatalogo?.nome || plano.codigo;

  const resultado = avaliarCompatibilidadePlano({ uso, limitesDestino, nomePlano });
  if (!resultado.compativel && toast?.warning) {
    toast.warning(resultado.mensagem);
  }
  return resultado.compativel;
}
